import { Injectable } from '@angular/core';
import { CookiesUtils } from "../../../../utils/cookies.utils";

@Injectable({
  providedIn: 'root'
})
export class AdPreviewPaginationService {
	readonly PAGE_SIZE_COOKIE_NAME = 'adPreviewPaginationPageSize';

	public currentPage = 1;
	public pageSizeOptions: number[] = [2, 5, 10, 15, 20];
	public pageSize: number = this.pageSizeOptions[1];

	constructor() {
		const pageSizeCookie = CookiesUtils.getCookieValue(this.PAGE_SIZE_COOKIE_NAME);

		if (pageSizeCookie) {
			const pageSizeCookieNumber = Number(pageSizeCookie);

			if (this.pageSizeOptions.includes(pageSizeCookieNumber)) {
				this.pageSize = pageSizeCookieNumber;
			}
		}
	}

	public set(newPageIndex: number, newPageSize: number) {
		this.currentPage = newPageIndex;
		this.pageSize = newPageSize;
	}

	public updatePagination(pageIndex: number, pageSize: number, length: number) {
		if (pageSize !== this.pageSize) {
			CookiesUtils.setCookieValue(this.PAGE_SIZE_COOKIE_NAME, pageSize.toString(), 365);
		}

		// handle packages being hidden/filtered
		if (Math.ceil(length / pageSize) < pageIndex + 1) {
			pageIndex--;
		}

		this.currentPage = pageIndex + 1;
		this.pageSize = pageSize;

		return {
			pageIndex: this.currentPage + 1,
			pageSize: this.pageSize
		};
	}
}
